module.exports = __webpack_public_path__ + "static/media/icon_kefu.2ab15707.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_kefu.png
// module id = 2163
// module chunks = 0